// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "QandA-module--hgwIcon-arrow-down--3g35R";
export var hgwIconArrowUp = "QandA-module--hgwIcon-arrow-up--3TxHN";
export var interpreterContent = "QandA-module--interpreterContent--eO7GZ";
export var interpreterContent__main = "QandA-module--interpreterContent__main--3xZwc";
export var questions = "QandA-module--questions--1Amr7";
export var questions__a = "QandA-module--questions__a--2AmYE";
export var showLimited = "QandA-module--showLimited--cCatE";
export var questions__q = "QandA-module--questions__q--G_Z1t";
export var animBarTypeA = "QandA-module--animBarTypeA--seOYo";
export var animBarTypeB = "QandA-module--animBarTypeB--2m6XW";
export var animBarTypeC = "QandA-module--animBarTypeC--2jShu";
export var animBarTypeD = "QandA-module--animBarTypeD--2uFgO";